import React from 'react'
import SliderTopResult from '../../component/slidercomponent/SliderTopResult'
import HomeTopResult from '../home/HomeTopResult'
import { Link } from "react-router-dom";


const TopResult = () => {
    return (
        <>

            <div className="site-breadcrumb" style={{ background: 'url(assets/school/about.webp)' }}>
                <div className="container">
                    <h2 className="breadcrumb-title">Top Result</h2>
                    <ul className="breadcrumb-menu">
                        <li><Link to="/">Home</Link></li>
                        <li className="active" style={{ color: "red" }}>Top Result</li>
                    </ul>
                </div>
            </div>

            <HomeTopResult />
            <br/>
            <br/>
            <br/>


        </>
    )
}

export default TopResult